/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_Media_LabelInputs */

const en_file_import_media_label = /** @type {(inputs: File_Import_Media_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const fr_file_import_media_label = /** @type {(inputs: File_Import_Media_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const de_file_import_media_label = /** @type {(inputs: File_Import_Media_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien`)
};

const it_file_import_media_label = /** @type {(inputs: File_Import_Media_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const ru_file_import_media_label = /** @type {(inputs: File_Import_Media_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`СМИ`)
};

const es_file_import_media_label = /** @type {(inputs: File_Import_Media_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medios de comunicación`)
};

const zh_cn2_file_import_media_label = /** @type {(inputs: File_Import_Media_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体`)
};

const ja_file_import_media_label = /** @type {(inputs: File_Import_Media_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディア`)
};

const hi_file_import_media_label = /** @type {(inputs: File_Import_Media_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिडिया`)
};

const pt_pt2_file_import_media_label = /** @type {(inputs: File_Import_Media_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mídia`)
};

/**
* | output |
* | --- |
* | "Media" |
*
* @param {File_Import_Media_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_media_label = /** @type {((inputs?: File_Import_Media_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_Media_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_import_media_label(inputs)
	if (locale === "de") return de_file_import_media_label(inputs)
	if (locale === "it") return it_file_import_media_label(inputs)
	if (locale === "ru") return ru_file_import_media_label(inputs)
	if (locale === "es") return es_file_import_media_label(inputs)
	if (locale === "zh-CN") return zh_cn2_file_import_media_label(inputs)
	if (locale === "ja") return ja_file_import_media_label(inputs)
	if (locale === "hi") return hi_file_import_media_label(inputs)
	if (locale === "pt-PT") return pt_pt2_file_import_media_label(inputs)
	return en_file_import_media_label(inputs)
});